/**
 * fingerprint.ts
 *
 * 設備指紋工具函數，用於唯一識別當前瀏覽器/設備。
 *
 * 使用 @fingerprintjs/fingerprintjs 生成穩定的訪客 ID（visitorId），
 * 結果在當前會話中緩存，避免重複計算。
 *
 * 典型用途：
 * - 離線設備領取（checkout）：確保同一 user 同一設備只有一個活躍 checkout
 * - 心跳維持（heartbeat）：標識發送心跳的設備
 * - 設備釋放（release）：精準釋放對應設備的 checkout 記錄
 */
import FingerprintJS from '@fingerprintjs/fingerprintjs';

/** 本次會話的指紋緩存（lazy 初始化，避免重複計算） */
let cached: string | null = null;

/**
 * 取得當前設備的指紋（visitorId）。
 *
 * - 首次調用：載入 FingerprintJS Agent、採集信號、返回 visitorId 並緩存
 * - 後續調用：直接返回緩存值，無需重新計算
 *
 * @returns 24 位英數字符串，如 `"abc123def456..."`
 */
export async function getDeviceFingerprint(): Promise<string> {
  if (cached) return cached;
  const fp = await FingerprintJS.load();
  const r = await fp.get();
  cached = r.visitorId;
  return cached;
}
